/**
 * Application Constants
 * Centralized constants for the Durga Puja Network application
 */

// Google Maps Configuration
export const GOOGLE_MAPS_CONFIG = {
  // Default API key (fallback)
  DEFAULT_API_KEY: 'AIzaSyAMqLoEGH7sXVl0_5bRLtj137Y_SIcTAak',
  
  // API version
  VERSION: 'weekly',
  
  // Required libraries
  LIBRARIES: ['places'] as const,
  
  // Map settings
  DEFAULT_ZOOM: 15,
  DEFAULT_CENTER: {
    lat: 22.5726, // Kolkata
    lng: 88.3639
  }
} as const;

// Application Settings
export const APP_CONFIG = {
  NAME: 'Durga Puja Network',
  VERSION: '1.0.0',
  DESCRIPTION: 'A global Durga Puja archive to help you connect, share and celebrate world\'s most vibrant cultural festival',
} as const;

// Map Marker Configuration
export const MAP_MARKER_CONFIG = {
  ICON: {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#EC4899"/>
        <circle cx="12" cy="12" r="6" fill="white"/>
        <circle cx="12" cy="12" r="3" fill="#EC4899"/>
      </svg>
    `),
    scaledSize: { width: 24, height: 24 },
    anchor: { x: 12, y: 24 }
  }
} as const;
